import { Button, createStyles, makeStyles, Theme } from '@material-ui/core'
import { PhotoCamera } from '@material-ui/icons'
import React from 'react'
import { SharedDataProvider } from '../../../shared/providers/SharedDataProvider'
import { ImageController } from '../../../shared/controllers/ImageController'
import { Company } from '../../models/Company'

interface CompanyLogoProps {
  company: Company
  companyLogo
  setCompanyLogo
  selectedLanguage
}

export const CompanyLogo = ({
  company,
  companyLogo,
  setCompanyLogo,
  selectedLanguage,
}: CompanyLogoProps) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      appContent: {
        minHeight: '86vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        alignItems: 'center',
      },
      dataContainer: {
        marginTop: 30,
        marginLeft: 20,
        marginRight: 20,
      },
      button: {
        width: '100%',
        borderRadius: '10px',
        backgroundColor: '#1c8033',
        color: 'white',
        variant: 'contained',
        margin: 5,
        fontSize: 15,
        '&:hover': {
          backgroundColor: '#1c8033',
        },
      },
      deleteButton: {
        width: '100%',
        borderRadius: '10px',
        backgroundColor: '#f44336',
        color: 'white',
        variant: 'contained',
        margin: 5,
        fontSize: 15,
        '&:hover': {
          backgroundColor: '#d32215',
        },
      },
      machinePicture: {
        objectFit: 'contain',
        objectPosition: 'center',
        width: '240px',
        borderRadius: '50%',
      },
      hiddenInput: {
        display: 'none',
      },
      companyLogo: {
        objectFit: 'contain',
        objectPosition: 'center',
        height: '240px',
        width: '360px',
      },
    })
  )
  const classes = useStyles()

  const sharedDataProvider = new SharedDataProvider()
  const imageController: ImageController = new ImageController()

  async function imageUpload() {
    // get image
    let files = document.getElementById('companyLogo').files

    // transform image into base64
    // prepare image by resizing etc
    let file = await imageController.prepareImageForUpload(files[0])
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      let base64 = reader.result
      setCompanyLogo(base64)
    }
  }

  return (
    <div>
      <div className={classes.dataContainer}>
        <img
          className={classes.companyLogo}
          src={
            companyLogo
              ? companyLogo
              : sharedDataProvider.host +
                '/companies/getCompanyLogo?id=' +
                company._id +
                '&' +
                new Date()
          }
        ></img>

        <input
          className={classes.hiddenInput}
          type="file"
          id="companyLogo"
          accept="image/*"
          onChange={(e) => imageUpload()}
        />
      </div>

      <div className={classes.dataContainer}>
        <label htmlFor="companyLogo">
          <Button
            className={classes.button}
            component="span"
            startIcon={<PhotoCamera />}
          >
            {
              {
                de: 'Logo Uploaden',
                en: 'Upload Logo',
                fr: 'Logo uploaden - FR',
              }[selectedLanguage]
            }
          </Button>
        </label>
      </div>
    </div>
  )
}
